import React from 'react'
import { useTranslation } from "react-i18next"
import { Grid } from '@material-ui/core'
import { LocalStorageService } from '../../../services'
import './dialog-reactivate-signature-request.css'
import { ButtonHLPure, DialogYesNoHLPure } from '..'

const DialogReactivateSignatureRequest = (props) => {
    const { t } = useTranslation()

    const containerLabelMessage = {
        textAlign: 'center',
        marginBlock: '20px',
    }

    let localStorageService = new LocalStorageService()
    const userSesionCurrent = localStorageService.getLocalStorageItem('user').userMetaData.userMifirma.email

    return (
        <>
            {(props?.signatureRequest?.signRequest?.signRequestStatus?.id === Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_REJECT) && props?.signRequestIsExpired === false && props.signRequest.user.email === userSesionCurrent) ?
                <div>
                    {/* Button to display the dialog */}
                    <ButtonHLPure
                        nameBtn={t('dialogReactivateSignatureRequest.buttonReactivateSignRequest')}
                        onClickBtn={props.toggleDialogReactivateSignatureRequest}
                    />

                    {/* Dialog to reactivate the signature request */}
                    {props.visibleDialogReactivateSignatureRequest &&
                        <DialogYesNoHLPure
                            titleDialog={t('dialogReactivateSignatureRequest.titleDialogReactivateSignatureRequest')}
                            textBtnCancel={t('dialogReactivateSignatureRequest.buttonCancel')}
                            cancel={props.toggleDialogReactivateSignatureRequest}
                            saveBtn={t('dialogReactivateSignatureRequest.buttonAccept')}
                            handleSubmit={props.onReactivateSignatureRequest}
                            loadingComponent={props.showLoadingRequesting}
                            saveError={props.showErrorRequesting}
                        >
                            {/* Container global */}
                            <Grid container xs={12} lg={12} md={12} sm={12} es={12}>
                                {/* Label y TextArea */}
                                <Grid item xs={12} lg={12} md={12} sm={12} es={12} style={containerLabelMessage}>
                                    <p>{t('dialogReactivateSignatureRequest.labelDoYouWantToReactivateSignRequest')}</p>
                                    <p>{t('dialogReactivateSignatureRequest.labelSignRequestReactivateSendToAllUsers')}</p>
                                </Grid>
                            </Grid>
                        </DialogYesNoHLPure>
                    }
                </div>
                : null}
        </>
    )
}

export { DialogReactivateSignatureRequest as default }